import { Props } from '../types';
import { NarrativeFeedback } from '../../NarrativeFeedback';
import { NarrativeHeader } from '../../PublicNarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';
import { getAuthorFairValueLabel } from '@/pages/Narrative/utils/author';

export const DesktopLayout = ({
  errors,
  values,
  onChange,
  onSetFairValue,
  isLoading,
  onSubmit,
  submitLabel,
  author,
  initialContentHtml,
  company,
  onReset,
  pastAnnualRevenueEarnings,
  narrativeId,
  companyId,
  calculationBreakDownOutput,
  onContentChange,
  onHeaderChange,
}: Props) => {
  return (
    <>
      <div className="grid grid-rows-[min-content_min-content_auto] content-start gap-x2">
        <NarrativeHeader
          errors={errors}
          values={values}
          onChange={onHeaderChange}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={submitLabel}
          author={author}
          companyId={companyId}
        />
        <NarrativeFeedback />
        <PublicNarrativeRichTextEditor
          onUpdate={onContentChange}
          defaultContent={initialContentHtml}
        />
      </div>

      <NarrativeSidebar
        company={company}
        onChange={onChange}
        onSetFairValue={onSetFairValue}
        values={values}
        onReset={onReset}
        readOnly={false}
        authorFairValueLabel={getAuthorFairValueLabel({
          displayName: author.displayName,
          name: author.name,
          narrativeType: 'USER',
        })}
        pastAnnualRevenueEarnings={pastAnnualRevenueEarnings}
        narrativeId={narrativeId}
        calculationBreakDownOutput={calculationBreakDownOutput}
      />
    </>
  );
};
